let name = 'codey';


const matrix2hexStr = matrix => {
    let result = [], temp = [];
    let data = matrix.split('');

    for (var j = 0, len = data.length; j < len; j += 8) {
        temp.push(data.slice(j, j + 8));
    }

    for (let item of temp) {
        let itemStr = item.join('');
        let hexStr = parseInt(itemStr, 2).toString(16);
        if (parseInt(itemStr, 2) < 16) {
            hexStr = `0${hexStr}`;
        }
        result.push(hexStr);
    }

    result = result.join('');
    return result;
};


const formatCodes = codes => {
    const facePanelDatas = codes.match(/codey\.face(?:_at)?\(([\s\S]*?)\)/g);
    if (!facePanelDatas) return codes;
    for (let index = 0; index < facePanelDatas.length; index++) {
        const oldData = facePanelDatas[index].split(',')[0].replace(/codey.face(?:_at)?\(/, '').replace(')', '');
        if (oldData.charAt(0) === "'" || oldData.charAt(0) === "\"" || oldData.length > 200) {
            const midData = oldData.trim().split("'").join('').replace(/\s/g, '');
            let newData = midData;
            if (midData.length > 34) {
                const newArr = [];
                let i = 0;
                while (i < 16) {
                    newArr[i] = '';
                    let j = 0;
                    while (j < 8) {
                        newArr[i] += midData[j * 16 + i];
                        j++;
                    }
                    i++;
                }
                newData = "'" + matrix2hexStr(newArr.join('')) + "'";
            }
            if (midData.length === 32) {
                newData = "'" + midData + "'";
            }
            codes = codes.replace(oldData, newData);
        }
    }
    return codes;
};

async function process(context) {
    context.code = formatCodes(context.code);
    return context;
}

export default {
    process,
    name,
}